import { Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import moment from "moment";

import PageHeader from "../Header/PageHeader";
import CustomChip from "../chips/CustomChip";
import styles from "../../styles/launchDetails/launchDetail.module.scss";
import ChangeStatus from "../chips/ChangeStatus";
import { getTestLaunchStatusVariant, getStatusIcon } from "../chips/ChipComponent/chipVariants";
import { formatStatusKey } from "./statusColorPallete";
import { TestLaunchStatus } from "../../enums/TestLaunchEnums";
import { LaunchTypeLabel } from "../../enums/ScheduleEnums";
import { updateTestLaunchStatus } from "../../utils/api/testlaunch_apis";
import { STATUS } from "../../utils/api/sharedfunction";
import { useSnackbar } from "../../utils/useSnackbar";


const LaunchDetailHeader = ({ launch, breadcrumbItems, refetch }) => {
  const {
    testLaunchId,
    key,
    status,
    createdAt,
    createdBy,
    configuration,
    isSequential,
    launchType,
    needsManualComplete,
  } = launch || {};
  const { showSnackbar } = useSnackbar();
  const theme = useTheme();
  const palette = theme.palette.customColor;

  const handleStatusChange = async (newStatus) => {
    try {
      const response = await updateTestLaunchStatus({ 
        launchId: testLaunchId, 
        status: newStatus 
      });
      
      if (response.status === STATUS.SUCCESS) {
        refetch();
        showSnackbar(response.message || `Test Launch status updated to ${formatStatusKey(newStatus)} successfully!`);
      } else {
        showSnackbar(response.error || "Status update failed", "error");
      }
    } catch (error) {
      showSnackbar("Failed to update status", "error");
      console.error('Error updating status', error);
    }
  };

  const typeLabel = LaunchTypeLabel[launchType] || launchType;

  return (
    <>
      <PageHeader
        title={`Launch ${key}`}
        titleChipComponent={
          <>
            {status && (
              <ChangeStatus
                status={status}
                availableStatuses={[TestLaunchStatus.COMPLETED, TestLaunchStatus.ABORTED]}
                getVariant={getTestLaunchStatusVariant}
                getIcon={getStatusIcon}
                formatStatus={formatStatusKey}
                onStatusChange={handleStatusChange}
                confirmChange={true}
                confirmTitle="Update Status"
                confirmMessage={
                  needsManualComplete && status !== TestLaunchStatus.COMPLETED
                    ? 'Mark this launch Completed to release the schedule/run gate for this type and environment. This cannot be undone.'
                    : 'Are you sure you want to change the Test Launch status? This action cannot be undone.'
                }
                size="medium"
                showTooltip={false}
              />
            )}
          </>
        }
        actions={
          <Stack direction="row" spacing={1} alignItems="center">
            {typeLabel && (
              <CustomChip
                label={typeLabel}
                color={palette.blue?.[50] || '#eff6ff'}
                textColor={palette.blue?.[600] || '#1d4ed8'}
                borderColor={palette.blue?.[200] || '#bfdbfe'}
                size="small"
              />
            )}
            <CustomChip
              label={isSequential ? 'Sequential' : 'Parallel'}
              color={isSequential ? palette.blue[50] : palette.green[50]}
              textColor={isSequential ? palette.blue[600] : palette.green[600]}
              borderColor={isSequential ? palette.blue[200] : palette.green[200]}
              size="small"
            />
          </Stack>
        }
        subTitleComponent={
          <Stack
            direction="row"
            spacing={3}
            className={styles['subtitle-stack']}
          >
            {createdAt && (
              <p className='subtitle-text' >
                Started: {moment(createdAt).format("MMM DD, YYYY hh:mm A")}
              </p>
            )}

            {createdBy && (
              <p className='subtitle-text' >Triggered by: {createdBy}</p>
            )}
            {configuration?.name && (
              <p className='subtitle-text' >
                Environment: {configuration.name}
              </p>
            )}
          </Stack>
        }
        breadcrumbItems={breadcrumbItems}
      />
    </>
  );
};

export default LaunchDetailHeader;
